import { StrikeZoneLocation } from 'interfaces/session/IStrikeZoneDefinition';
import React from 'react';
import { brand } from 'styles/Colors';

interface IProps {
  enabledPlanes: StrikeZoneLocation[];
}

const DISABLED_PLANE_FILL = 'white';

export const StrikeZonePlanesGraphic: React.FC<IProps> = (props) => {
  const { enabledPlanes } = props;

  const getPlaneFill = (locationType: StrikeZoneLocation): string => (enabledPlanes.includes(locationType) ? brand : DISABLED_PLANE_FILL);

  return (
    <svg
      width='175'
      height='226'
      viewBox='0 0 175 226'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='strike-zone-planes-graphic'
      style={{ minWidth: '175px' }}
    >
      <g opacity='0.6' filter='url(#szPlaneShadowFront)'>
        <path d='M21.127 56.0357L98.5917 16.5991V98.2893L21.127 137.726L21.127 56.0357Z' fill={getPlaneFill(StrikeZoneLocation.Front)} />
        <path d='M98.4033 98.1733L21.3154 137.417L21.3154 56.1509L98.4033 16.9067V98.1733Z' stroke='#7B7B7B' strokeWidth='0.377293' />
      </g>
      <g opacity='0.6' filter='url(#szPlaneShadowMiddle)'>
        <path d='M48.8945 87.2003L126.359 47.7637V129.454L48.8945 168.89L48.8945 87.2003Z' fill={getPlaneFill(StrikeZoneLocation.Middle)} />
        <path d='M126.171 129.338L49.083 168.582L49.083 87.3154L126.171 48.0713V129.338Z' stroke='#7B7B7B' strokeWidth='0.377293' />
      </g>
      <path
        opacity='0.7'
        d='M110.602 137.579L125.939 152.321L118.057 204.636L49.0267 195.647L21.015 165.054L49.0492 150.735'
        stroke='#A0A0A0'
        strokeWidth='0.65649'
      />
      <path
        opacity='0.7'
        d='M117.774 204.635L118.022 97.3142M153.408 79.2834L125.943 48.2974L98.4356 17.3115L21.0137 56.5386V165.054M49.0256 195.646V88.4383M118.022 97.3142L125.943 48.2974M118.022 97.3142L49.0256 88.4383M125.943 48.2974V152.388M49.0256 88.4383L21.0137 56.5386M49.0256 88.4383L75.9434 119.424M98.4356 17.3115L98.4785 62.4583'
        stroke='#A0A0A0'
        strokeWidth='0.65649'
        strokeDasharray='2.82 2.82'
      />
      <path opacity='0.3' d='M98.4785 62.3818V125.762' stroke='#A0A0A0' strokeWidth='0.65649' strokeDasharray='2.82 2.82' />
      <path opacity='0.3' d='M75.5863 137.112L98.4356 125.762L112.189 139.11' stroke='#A0A0A0' strokeWidth='0.65649' />
      <path opacity='0.3' d='M49.0215 150.786L75.6619 137.096' stroke='#A0A0A0' strokeWidth='0.603669' />
      <g opacity='0.6' filter='url(#szPlaneShadowBack)'>
        <path d='M75.791 118.163L153.256 78.7261V160.416L75.791 199.853V118.163Z' fill={getPlaneFill(StrikeZoneLocation.Back)} />
        <path d='M153.067 160.3L75.9795 199.544V118.278L153.067 79.0337V160.3Z' stroke='#7B7B7B' strokeWidth='0.377293' />
      </g>
      <defs>
        <filter
          id='szPlaneShadowFront'
          x='0.000192642'
          y='-0.000123024'
          width='119.718'
          height='163.38'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4.52752' />
          <feGaussianBlur stdDeviation='10.5634' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
        <filter
          id='szPlaneShadowMiddle'
          x='27.7678'
          y='31.1644'
          width='119.718'
          height='163.38'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4.52752' />
          <feGaussianBlur stdDeviation='10.5634' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
        <filter
          id='szPlaneShadowBack'
          x='54.6643'
          y='62.1268'
          width='119.718'
          height='163.38'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4.52752' />
          <feGaussianBlur stdDeviation='10.5634' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};
